'use client';

import { useState } from 'react';
import type { FaqItem } from '@/data/pseo/content';

interface Props {
  items: FaqItem[];
}

export function PseoFaq({ items }: Props) {
  const [open, setOpen] = useState<number | null>(null);

  if (!items.length) return null;

  return (
    <div>
      <h2 className="mb-6 text-xl sm:text-[22px] font-medium tracking-[-0.02em] leading-snug text-[#181a1a]">
        Frequently asked questions
      </h2>
      <div style={{ borderTop: '1px solid #e5e5e5' }}>
        {items.map((item, idx) => (
          <div key={idx} style={{ borderBottom: '1px solid #e5e5e5' }}>
            <button
              type="button"
              onClick={() => setOpen(open === idx ? null : idx)}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '16px 0',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
                gap: 16,
              }}
            >
              <span style={{ fontSize: 15, fontWeight: 600, color: '#000', lineHeight: 1.4 }}>
                {item.question}
              </span>
              <span
                style={{
                  fontSize: 20,
                  color: '#000',
                  flexShrink: 0,
                  display: 'inline-block',
                  transition: 'transform 0.2s',
                  transform: open === idx ? 'rotate(45deg)' : 'rotate(0deg)',
                }}
              >
                +
              </span>
            </button>
            {open === idx && (
              <div style={{ fontSize: 14, color: '#646464', lineHeight: 1.7, paddingBottom: 20 }}>
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
